import { ForwardedRef, forwardRef, Ref } from 'react';
import { Adornment, InputAdornment } from './InputAdornment';
import { Group, Input as AriaInput, InputProps, GroupProps } from 'react-aria-components';

import styles from './Input.module.css';

export type Props = Pick<GroupProps, 'isDisabled' | 'isInvalid'> &
  Pick<InputProps, 'placeholder'> & {
    maxWidth?: string | number;
    startAdornment?: Adornment;
    endAdornment?: Adornment;
    /**
     * A ref to the group: the bordered box drawn around the input and its adornments, as opposed to
     * the `input` itself, which this component's own `ref` points at. Anything that has to line up
     * with the field — a popover under it, most obviously — wants this one, because the input inside
     * starts after the leading adornment and stops before the trailing one.
     */
    groupRef?: Ref<HTMLDivElement>;
  };

export const InputGroup = forwardRef(function _InputGroup(
  {
    placeholder,
    isDisabled,
    isInvalid,
    maxWidth,
    startAdornment: StartAdornment,
    endAdornment: EndAdornment,
    groupRef,
  }: Props,
  ref: ForwardedRef<HTMLInputElement>,
) {
  return (
    <Group ref={groupRef} className={styles.group} isDisabled={isDisabled} isInvalid={isInvalid} style={{ maxWidth }}>
      {StartAdornment ? <InputAdornment>{StartAdornment}</InputAdornment> : null}
      <AriaInput placeholder={placeholder} ref={ref} />
      {EndAdornment ? <InputAdornment>{EndAdornment}</InputAdornment> : null}
    </Group>
  );
});
